// no itx for this file
"use strict";

const validator = require("./validator");
const XMLParser = require("./xmlparser/XMLParser");
const XMLBuilder = require("./xmlbuilder/json2xml");

export default {
  XMLParser: XMLParser,
  XMLValidator: validator,
  XMLBuilder: XMLBuilder,
};
